module.exports = __webpack_public_path__ + "img/8923.a388826d.jpg";